import React from 'react';
import { CountryCode } from 'api/types/store';
import { Select } from 'ui-kit';
import { getCountryByCode, stripeCrossBorderCountryCodes } from 'utils/geo';

export interface IStripeCountrySelect {
  value: string;
  onChange: ({ value }: { value: CountryCode }) => void;
}

const OPTIONS = stripeCrossBorderCountryCodes.map((code) => ({
  label: getCountryByCode(code).name,
  value: code,
}));

const StripeCountrySelect = ({ value, onChange }: IStripeCountrySelect) => (
  <Select
    showSearch
    filterOption={(input, option) => {
      const value = option.value.toLowerCase();
      const inputValue = input.toLowerCase();
      return value === inputValue || option.children.toLowerCase().indexOf(inputValue) >= 0;
    }}
    onChange={(value) => onChange({ value: value as CountryCode })}
    value={value}
    options={OPTIONS}
  />
);

export default StripeCountrySelect;
